import { Action, createReducer, on } from '@ngrx/store';
import { entityMaquinaMovilAddFailure, entityMaquinaMovilAddRequest, entityMaquinaMovilAddSuccess, entityMaquinaMovilDeleteFailure, entityMaquinaMovilDeleteRequest, entityMaquinaMovilDeleteSuccess, entityMaquinaMovilLoadFailure, entityMaquinaMovilLoadRequest, entityMaquinaMovilLoadSuccess, entityMaquinaMovilUpdateFailure, entityMaquinaMovilUpdateRequest, entityMaquinaMovilUpdateSuccess } from './entity-maquinas-moviles.actions';
import { EntityMaquinaMovilState, entityMaquinaMovilAdapter, initialState } from './entity-maquinas-moviles.state';

const reducer = createReducer(
  initialState,
  on(entityMaquinaMovilLoadRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entityMaquinaMovilAddRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entityMaquinaMovilUpdateRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entityMaquinaMovilDeleteRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entityMaquinaMovilLoadSuccess, (state, { items }) =>
    entityMaquinaMovilAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  on(entityMaquinaMovilLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityMaquinaMovilAddSuccess, (state, { item }) => {
    return entityMaquinaMovilAdapter.addOne(item, {
      ...state,
      hasAddedSuccess: true,
      isLoading: false,
      error: null
    });
  }),
  on(entityMaquinaMovilUpdateSuccess, (state, { item }) => {
    return entityMaquinaMovilAdapter.upsertOne(item, {
      ...state,
      hasAddedSuccess: true,
      isLoading: false,
      error: null
    });
  }),
  on(entityMaquinaMovilDeleteSuccess, (state, { item }) => {
    return entityMaquinaMovilAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
    });
  }),
  on(entityMaquinaMovilAddFailure, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  })),
  on(entityMaquinaMovilDeleteFailure, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  })),
  on(entityMaquinaMovilUpdateFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  }),
  ))

export function maquinaMovilReducer(
  state: EntityMaquinaMovilState | undefined,
  action: Action
) {
  return reducer(state, action);
}
